export default __webpack_public_path__ + "static/media/LEGA9445.fcd6ea7a.jpg";